// Decode HTML entities for browser and Node (emoji, &amp;, etc.)
export function decodeEntities(s = ''): string {
  if (!s) return '';
  if (typeof window !== 'undefined') {
    const d = document.createElement('textarea');
    d.innerHTML = s;
    return d.value;
  }
  return s
    .replace(/&#(\d+);/g, (_, n) => String.fromCodePoint(+n))
    .replace(/&#x([0-9a-f]+);/gi, (_, h) => String.fromCodePoint(parseInt(h, 16)))
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&apos;/g, "'");
}
